module.exports = __webpack_public_path__ + "static/media/3_6.28dbf402.png";